/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class StaticDocumentsModel {
        public staticDocument: Wars.Domain.Model.StaticDocument;
        public systemLevel: Wars.Domain.Model.SystemLevel;
        public staticDocuments: Array<Wars.Domain.Model.StaticDocument>;
        public fileUploadModel: models.FileUploadModel;
        public uploadedFiles: Wars.Domain.Model.Dtos.DocumentDto[];
        public name: string;
        public description: string;
        public newStaticDocument: boolean;
        public processConfigurationId: string;

        public constructor(
            private manageStaticDocumentsService: services.ManageStaticDocumentsService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService,
            private growl: angular.growl.IGrowlService,
            private $routeParams: angular.route.IRouteParamsService)
        {
            this.newStaticDocument = false;
            this.staticDocuments = [];
            this.uploadedFiles = [];

            this.processConfigurationId = $routeParams["id"];

            if (this.processConfigurationId) {
                manageStaticDocumentsService.getStaticDocumentsForProcessConfiguration(this.processConfigurationId).then(d => {
                    this.staticDocuments = d;
                });
            } else {
                systemLevelService.getSystemLevelStaticDocuments().then(
                    (systemLevel) => {
                        this.systemLevel = systemLevel;
                        this.staticDocuments = systemLevel.myStaticDocuments;
                    });
            }
        }

        public addStaticDocument() {
            this.newStaticDocument = true;
            this.fileUploadModel = new models.FileUploadModel();
            if (this.processConfigurationId) {
                this.fileUploadModel.processConfigId = this.processConfigurationId;
            } else {
                this.fileUploadModel.systemLevelId = this.systemLevel.id;
            }
            this.uploadedFiles = [];
            this.name = '';
            this.description = '';
        }

        public removeStaticDocument(staticDocument: Wars.Domain.Model.StaticDocument) {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "StaticDocument",
                staticDocument.id,
                "Static Document Successfully Deleted",
                () => {
                    this.staticDocuments.remove(staticDocument);
                },
                "Static Document Could not be Deleted");
        }

        public add() {
            this.staticDocument.name = this.name;
            this.staticDocument.descriptiveComment = this.description;

            if (!this.staticDocument.name) {
                this.growl.error("Please enter a name for this Static Document", { ttl: 5000 });
            }
            else {
                if (this.processConfigurationId) {
                    this.staticDocument.processConfiguration_id = this.processConfigurationId;
                } else {
                    this.staticDocument.systemLevel_id = this.systemLevel.id;
                }

                this.manageStaticDocumentsService.saveAllChanges(() => {
                    this.staticDocuments.push(this.staticDocument);
                    this.newStaticDocument = false;
                });
            }
        }

        public cancel() {
            this.manageStaticDocumentsService.rejectChanges();
        }

        public save() {
            var changes = this.manageStaticDocumentsService.getChanges("StaticDocument");
            var anyMissingNames = Enumerable.from(changes).any(i => !i.name);
            if (anyMissingNames) {
                this.growl.error("Please enter a name for this Static Document", { ttl: 5000 });
            } else {
                this.manageStaticDocumentsService.saveAllChanges();
            }
        }
    }
}